import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What style of martial arts do you teach?',
  answer: 'We teach Olympic-style Taekwondo, a dynamic martial art known for its powerful kicking techniques, discipline, and focus.'
}, {
  question: 'Is it safe for beginners?',
  answer: 'Absolutely. Safety is our top priority. Our experienced coaches ensure a structured, controlled environment where beginners can learn at their own pace.'
}, {
  question: 'Do I need to be in shape to start?',
  answer: 'Not at all! Martial arts is a great way to get in shape. Our classes are designed to help you build fitness gradually as you learn the techniques.'
}, {
  question: 'Can my whole family train together?',
  answer: 'Yes! We offer specific Family Classes where parents and children can train on the same mat, making it a great shared activity.'
}];
export function MartialArtsNearMeFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2454" />;
}